import {
    WorkspaceView,
    WorkspaceColumn,
} from "@common/types/views/workspaceViews";

export const DefaultWorkspaceView: WorkspaceView = {
    type: "workspace",
    options: {
        selection: false,
        bulkActions: false,
    },
    columns: [
        { id: WorkspaceColumn.NAME },
        { id: WorkspaceColumn.ENTITIES },
        { id: WorkspaceColumn.TEAM },
    ],
    filters: {},
};
